import { useState } from "react";
import { Chart } from "primereact/chart";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import Spinner from "../../components/spinner";

const MachineUsageChart = ({ dashboardData, loading }) => {
  const [selectedMachine, setSelectedMachine] = useState("all");
  const [selectedTimeInterval, setSelectedTimeInterval] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const kioskData = dashboardData?.machineUsageStats || [];
  const labels = [...new Set(kioskData.map((item) => item.dateTimeRange))];

  const machineIds = [
    ...new Set(
      kioskData.flatMap(({ stats }) => stats.map(({ kioskId }) => kioskId))
    ),
  ];

  const kioskUsageMap = machineIds.reduce((acc, machine) => {
    acc[machine] = new Array(labels.length).fill(0);
    return acc;
  }, {});

  kioskData.forEach(({ dateTimeRange, stats }) => {
    const index = labels.indexOf(dateTimeRange);
    if (index !== -1) {
      stats.forEach(({ kioskId, usageInMinutes }) => {
        if (kioskUsageMap[kioskId]) {
          kioskUsageMap[kioskId][index] = usageInMinutes;
        }
      });
    }
  });

  const allUsageValues = machineIds.flatMap(
    (machine) => kioskUsageMap[machine]
  );
  const maxUsage = Math.max(...allUsageValues, 10);
  const stepSize = Math.ceil(maxUsage / 5);

  const generateColors = (count) => {
    const predefinedColors = [
      "#42A5F5",
      "#FFA726",
      "#66BB6A",
      "#FFEB3B",
      "#AB47BC",
      "#EC407A",
    ];
    return machineIds.reduce((acc, machine, index) => {
      acc[machine] = predefinedColors[index % predefinedColors.length];
      return acc;
    }, {});
  };

  const colors = generateColors(machineIds.length);

  const getFilteredChartData = () => {
    const filteredMachines =
      selectedMachine === "all" ? machineIds : [selectedMachine];

    return {
      labels,
      datasets: filteredMachines.map((machine) => ({
        label: machine.replace("KIOSK-", "KIOSK "),
        backgroundColor: colors[machine] || "#42A5F5",
        data: kioskUsageMap[machine] || new Array(labels.length).fill(0),
      })),
    };
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      y: {
        title: { display: true, text: "Average Usage Time (In Minutes)" },
        ticks: { stepSize, beginAtZero: true },
      },
    },
  };

  return (
    <>
      <div className="filters-container">
        <h3 className="text-xl font-bold mb-0">Machine Usage</h3>
        <div className="filters">
          <Calendar
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.value)}
            placeholder="Select Date"
            showIcon
          />
          <Dropdown
            value={selectedMachine}
            options={[
              { label: "All Machines", value: "all" },
              ...machineIds.map((machine) => ({
                label: machine.replace("KIOSK-", "KIOSK "),
                value: machine,
              })),
            ]}
            onChange={(e) => setSelectedMachine(e.value)}
            placeholder="Select Machine"
          />
          <Dropdown
            value={selectedTimeInterval}
            options={[
              { label: "Last 24 hours", value: "24h" },
              { label: "Last 7 days", value: "7d" },
              { label: "Last 30 days", value: "30d" },
            ]}
            onChange={(e) => setSelectedTimeInterval(e.value)}
            placeholder="Select Time Interval"
          />
        </div>
      </div>
      <Chart
        type="bar"
        data={getFilteredChartData()}
        options={chartOptions}
        style={{ height: "400px" }}
      />
    </>
  );
};

export default MachineUsageChart;
